import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

/**
 * Séquençage V2 — Périmètre d'une souscription, choisi par le CGP avant l'appel /init.
 * Aligné sur le SubscriptionScopeEnum backend.
 */
export type SubscriptionScope = 'LEGAL_ONLY' | 'FULL';

interface ScopeOption {
  value: SubscriptionScope;
  suffix: string;
  title: string;
  subtitle: string;
  svg: string;
}

/**
 * Séquençage V2 — Écran de choix du périmètre de souscription (LEGAL_ONLY / FULL),
 * présenté juste avant la création du pledge (/init), aussi bien pour le parcours de
 * souscription classique que pour les opérations (ARBITRAGE / VERSEMENT).
 *
 * Composant présentationnel : reprend le pattern visuel de `subscription-options`
 * (cartes `residence-box` cliquables). Émet `(scopeSelected)` à la confirmation.
 */
@Component({
  selector: 'subscription-scope-choice',
  templateUrl: './subscription-scope-choice.component.html',
  styleUrls: ['./subscription-scope-choice.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SubscriptionScopeChoiceComponent {
  /** Affiche le bouton « Question précédente » (parcours classique). Masqué pour les opérations. */
  @Input() showPrevious = true;
  @Input() fullScopeAllowed = true;

  @Output() scopeSelected = new EventEmitter<SubscriptionScope>();
  @Output() prevClicked = new EventEmitter<void>();

  selected: SubscriptionScope | null = null;

  private readonly allOptions: ScopeOption[] = [
    {
      value: 'LEGAL_ONLY',
      suffix: 'A',
      title: 'Juridique uniquement',
      subtitle: 'Pack Réglementaire + Pack Adéquation',
      svg: 'file.svg',
    },
    {
      value: 'FULL',
      suffix: 'B',
      title: 'Souscription complète',
      subtitle: 'Pack Réglementaire + Adéquation + Bulletin de Souscription',
      svg: 'sign.svg',
    },
  ];

  get options(): ScopeOption[] {
    return this.fullScopeAllowed
      ? this.allOptions
      : this.allOptions.filter(option => option.value !== 'FULL');
  }

  select(option: ScopeOption): void {
    this.selected = option.value;
  }

  confirm(): void {
    if (this.selected) {
      this.scopeSelected.emit(this.selected);
    }
  }

  prev(): void {
    this.prevClicked.emit();
  }
}
